import { IconStyle } from "@iventis/domain-model/model/iconStyle";
import { Status } from "@iventis/domain-model/model/status";
import { StyleType } from "@iventis/domain-model/model/styleType";
import { createLiteralStyleValue, createStaticStyleValue } from "@iventis/layer-style-helpers";
import { FeatureCollection, Point } from "geojson";
import { DomainLayer } from "../../state/map.state.types";
import { ViewByStatus } from "../../types/layer-view-by";
import { LayerStorageScope } from "../../types/store-schema";
import { defaultIconStyle } from "../../utilities/default-style-values";
import { Layer } from "./layer";
import { crossSpriteName } from "../constants";

/** Generic layer which shows the split indicator on a line map object */
export abstract class SplitLineIndicatorLayer extends Layer<FeatureCollection<Point> | undefined, IconStyle> {
    protected source: FeatureCollection<Point> | undefined = { type: "FeatureCollection", features: [] };

    protected readonly layerId = "split-line-indicator-layer";

    protected readonly sourceId = this.layerId;

    protected readonly splitLineIndicatorLayer: DomainLayer = {
        id: this.layerId,
        status: Status.Active,
        mapId: "",
        visible: true,
        locked: false,
        imported: false,
        name: "split-line-indicator",
        styleType: StyleType.Icon,
        areaStyle: undefined,
        lineStyle: undefined,
        pointStyle: undefined,
        iconStyle: {
            ...defaultIconStyle,
            iconImage: createStaticStyleValue(crossSpriteName),
            rotation: createLiteralStyleValue(0, "rotation"),
        },
        modelStyle: undefined,
        lineModelStyle: undefined,
        areaModelStyle: undefined,
        previewIconUrl: "",
        dataFields: [],
        tooltipDataFieldIds: [],
        createdByUserId: "",
        createdByUserName: "",
        createdAt: undefined,
        lastUpdatedByUserId: "",
        lastUpdatedByUserName: "",
        lastUpdatedAt: undefined,
        viewBy: ViewByStatus.OBJECT,
        source: this.layerId,
        stamp: this.sourceId,
        selected: false,
        storageScope: LayerStorageScope.LocalOnly,
        remote: false,
    };

    public updateLocalSource(updatedPoint: FeatureCollection<Point> | undefined): void {
        this.source = updatedPoint;
    }
}
